import { __generator } from "tslib";
import React from 'react';
import { call, put, select, race, take } from 'redux-saga/effects';
import { request } from '../../xhr';
import { getCurrentGallection, getGallectionById } from '../selectors';
import { deselectAll } from '../actions';
import setGallectionCover from './setGallectionCover';
import updateGallectionSize from './updateGallectionSize';
import { isPremiumGallection, getPremiumGallectionType, } from '../../utils/gallections';
import { pushGlobalConfirmationModalForMM, confirmYes, confirmNo, } from '../../Modals/redux/actionCreators';
import { Warning } from '../../Icons/Confirmations';
export default function (action) {
    var _a, deviationIds, targetFolderId, _b, currentGallection, targetGallection, isToPremiumFolder, premiumType, confirmationTextTransKey, no, params;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, deviationIds = _a.deviationIds, targetFolderId = _a.targetFolderId;
                return [4 /*yield*/, select(function (state) { return ({
                        currentGallection: getCurrentGallection(state),
                        targetGallection: getGallectionById(state, targetFolderId),
                    }); })];
            case 1:
                _b = _c.sent(), currentGallection = _b.currentGallection, targetGallection = _b.targetGallection;
                isToPremiumFolder = isPremiumGallection(targetGallection);
                if (!isToPremiumFolder) return [3 /*break*/, 4];
                premiumType = getPremiumGallectionType(targetGallection);
                confirmationTextTransKey = void 0;
                if (premiumType === 'paid') {
                    confirmationTextTransKey =
                        'mediapopup.confirmationPopup.moveDeviation.text.fromFreeToPaid';
                }
                else {
                    confirmationTextTransKey =
                        'mediapopup.confirmationPopup.moveDeviation.text.fromFreeToWatchersOnly';
                }
                return [4 /*yield*/, put(pushGlobalConfirmationModalForMM({
                        titleTransKey: 'mediapopup.confirmationPopup.moveDeviation.title',
                        textTransKey: confirmationTextTransKey,
                        confirmBtnLabelTransKey: 'mediapopup.confirmationPopup.moveDeviation.confirm',
                        cancelBtnLabelTransKey: 'popup.cancel',
                        icon: React.createElement(Warning, null),
                    }))];
            case 2:
                _c.sent();
                return [4 /*yield*/, race({
                        yes: take(confirmYes),
                        no: take(confirmNo),
                    })];
            case 3:
                no = (_c.sent()).no;
                if (no) {
                    return [2 /*return*/];
                }
                _c.label = 4;
            case 4: return [4 /*yield*/, put(deselectAll())];
            case 5:
                _c.sent();
                return [4 /*yield*/, call(setGallectionCover, {
                        folderId: targetFolderId,
                        deviationId: deviationIds[0],
                        onlyIfMissing: true,
                    })];
            case 6:
                _c.sent();
                return [4 /*yield*/, call(updateGallectionSize, targetFolderId, deviationIds.length)];
            case 7:
                _c.sent();
                params = {
                    type: currentGallection.type,
                    target_folderid: targetFolderId,
                    deviationids: deviationIds,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/copy_deviations',
                        data: params,
                    })];
            case 8:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=copyDeviations.js.map